import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { message } from 'antd';
import errorReporter from '@app/errorReporter';
import VirtualTourDetailsHeader from './VirtualTourDetailsHeader';
import VirtualTourDetailsBody from './VirtualTourDetailsBody';
import AngularLocationServiceContext from '../../business/ManageAppointmentPage/AngularLocationServiceContext';

function VirtualTourDetails({
  isMyBusiness,
  $routeParams,
  ExternalAuth,
  $location,
  $rootScope,
}) {
  const { retsId, dashboardId } = ExternalAuth?.auth || {};
  const virtualTourId = $routeParams.tourId;
  const [virtualTour, setVirtualTour] = useState(null);
  const [listing, setListing] = useState({});
  const [virtualShowingDomain, setVirtualShowingDomain] = useState('');
  const [isCancelled, setIsCancelled] = useState(false);

  useEffect(() => {
    const fetchTour = async () => {
      const isExternal = retsId || dashboardId;
      try {
        const { data } = await axios.get(
          isExternal
            ? `/external/virtual_tour/${virtualTourId}`
            : `/virtual_tour/${virtualTourId}`,
          {
            params: { retsId, dashboardId },
          },
        );

        if (data.redirectFeatureMissing) {
          $location.path('/feature-missing');
          return;
        }

        setVirtualTour(data);
      } catch (error) {
        errorReporter.error(error);
        message.error('Tour can not be found or has been cancelled');
      }
    };

    const fetchListing = async () => {
      // TODO: Should refactor this function to use 'ExternalAuth.auth.listing' instead
      try {
        if (retsId) {
          const { data } = await axios.get(`/external/listing/${retsId}`);
          setListing(data);
        } else if (dashboardId) {
          const result = await axios.get(`/external/dash/${dashboardId}`);
          let { data } = result;
          const { newDashboardId } = result;
          if (newDashboardId) {
            ({ data } = await axios.get(`/external/dash/${newDashboardId}`));
          }
          setListing(data.listing);
        }
      } catch (error) {
        errorReporter.error(error);
        message.error('Listing can not be found');
      }
    };

    const fetchVirtualShowingUrl = async () => {
      try {
        const { data } = await axios.get('/secrets/virtual_showing_domain');
        setVirtualShowingDomain(data.virtualShowingDomain);
      } catch (error) {
        errorReporter.error(error);
      }
    };

    fetchTour();
    fetchListing();
    fetchVirtualShowingUrl();
  }, []);

  return (
    <AngularLocationServiceContext.Provider value={{ $location }}>
      <div>
        {virtualTour && (
          <div>
            <VirtualTourDetailsHeader
              virtualTour={virtualTour}
              $location={$location}
              setVirtualTour={setVirtualTour}
              $rootScope={$rootScope}
              retsId={retsId}
              dashboardId={dashboardId}
              isMyBusiness={isMyBusiness}
              virtualShowingDomain={virtualShowingDomain}
              isCancelled={isCancelled}
              setIsCancelled={setIsCancelled}
            />
            <VirtualTourDetailsBody
              isCancelled={isCancelled}
              listing={listing}
              virtualTour={virtualTour}
              retsId={retsId}
              dashboardId={dashboardId}
              virtualShowingDomain={virtualShowingDomain}
            />
          </div>
        )}
      </div>
    </AngularLocationServiceContext.Provider>
  );
}

export default VirtualTourDetails;
